import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe, 'de');

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector } from '@angular/core';

import { createCustomElement } from "@angular/elements";

import { QuestionnaireComponent } from './questionnaire/questionnaire.component';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        QuestionnaireComponent
    ]
})
export class AppModule {
    constructor(private injector: Injector) { }

    ngDoBootstrap() {

        const QuestHostElement = createCustomElement(QuestionnaireComponent, {
            injector: this.injector
        });
        customElements.define("questionnaire-host-element", QuestHostElement);

    }
}
